export const receiveType: number = 2